/* eslint-disable complexity */
import app from 'Cloud/Application/app';
import { Public } from 'Cloud/Application/Public';
import config from 'Cloud/config';
import $ from 'jquery';
import debounce from 'lodash.debounce';
import throttle from 'lodash.throttle';
import { HIDE_ADS } from 'reactApp/appHelpers/configHelpers';
import { isReactMobilePublic } from 'reactApp/sections/MobilePublicPage/isReactMobilePublic';

const IS_PUBLIC = Public && Public.isPublic();
const IS_MOBILE = config.get('MOBILE_BROWSER');
const IS_PHONE = config.get('PHONE_BROWSER');
const MIN_HEIGHT = 320;
const MIN_HEIGHT_MOBILE = 198;
const IS_OPERA = String(window.opera) === '[object Opera]';
const IS_PUBLIC_SHOVE = config.get('PUBLIC_SHOVE');

const DOM_RIGHT_COL_BANNER = config.get('DOM_RIGHT_COL_BANNER');
const DOM_RIGHT_COL_BANNER_EMPTY = config.get('DOM_RIGHT_COL_BANNER_EMPTY');
const DOM_RIGHT_COL_BANNER_NOT_INITED = config.get('DOM_RIGHT_COL_BANNER_NOT_INITED');

let isStickyBanners = false;
let isInited = false;

let createMutationObserver;
function detectMutationObserverType() {
    if (createMutationObserver !== void 0) {
        return;
    }

    createMutationObserver = window.MutationObserver
        ? function (callback) {
              return new window.MutationObserver(callback);
          }
        : window.webkitMutationObserver
        ? function () {
              return new window.webkitMutationObserver(callback);
          }
        : null;
    createMutationObserver = null;
    if (createMutationObserver === null) {
        let $test = $('<div style="position:absolute;visibility:hidden;"><div class="a">test</div><div>')
            .appendTo('body')
            .one('DOMSubtreeModified', function () {
                createMutationObserver = function (callback) {
                    return {
                        _els: [],
                        observe(element) {
                            if (!element) {
                                return;
                            }
                            this._els.push(element);
                            element.addEventListener('DOMSubtreeModified', callback, false);
                        },
                        disconnect(el) {
                            this._els.forEach(function (el) {
                                el.removeEventListener('DOMSubtreeModified', callback, false);
                            });
                        },
                    };
                };
            })
            .find('.a')
            .remove();
        setTimeout(function () {
            $test.remove();
            $test = null;
        }, 1000);
    }
}

const storedListItems = [];

const showYandexDirectItems = debounce(function (bodyHeight) {
    if (IS_MOBILE || IS_PUBLIC_SHOVE) {
        return;
    }

    const $banner = $('.' + DOM_RIGHT_COL_BANNER);
    const minBanners = config.get('MRG_CTX_RIGHT_COL_MIN_ITEMS');

    let bannerHeight;
    let itemOuterHeight;
    let placeHolder;
    let storedListItem;
    let item;
    let items;
    let itemsSelector;

    if ($banner.length) {
        itemsSelector = $banner[0].getAttribute('data-item-selector') || '.yap-item, .b-context__item';
        items = $banner.find(itemsSelector);

        if (!items.length) {
            itemsSelector = config.get('MRG_CTX_RIGHT_COL_ITEM_SEL');

            if (itemsSelector) {
                items = $banner.find(itemsSelector);
            }
        }

        bannerHeight = $banner.outerHeight();
        if (bannerHeight > bodyHeight) {
            for (let l = items.length, i = l - 1; i >= minBanners; i--) {
                item = items[i];

                if (item) {
                    itemOuterHeight = item.offsetHeight + (parseInt($(item).parents('table').eq(0).css('border-spacing'), 10) || 0);
                    // placeHolder = document.createElement(item.tagName);
                    placeHolder = document.createElement('i');

                    storedListItems.push({
                        item,
                        placeHolder,
                        itemOuterHeight,
                    });

                    item.parentNode.replaceChild(placeHolder, item);
                    bannerHeight = $banner.outerHeight();
                }
                if (bannerHeight <= bodyHeight) {
                    break;
                }
            }
        } else {
            for (let l = storedListItems.length, i = l - 1; i >= 0; i--) {
                storedListItem = storedListItems[i];

                itemOuterHeight = storedListItem.itemOuterHeight;
                item = storedListItem.item;
                placeHolder = storedListItem.placeHolder;

                if (item && placeHolder) {
                    if (itemOuterHeight + bannerHeight <= bodyHeight) {
                        placeHolder.parentNode.replaceChild(item, placeHolder);
                        bannerHeight = $banner.outerHeight();
                        storedListItems.pop();
                    } else {
                        break;
                    }
                }
            }
        }
    }

    if (!showYandexDirectItems.__observed) {
        if (createMutationObserver) {
            showYandexDirectItems.__observed = true;

            let observer;
            const do_showYandexDirectItems = function () {
                observer.disconnect($banner[0]);
                showYandexDirectItems(publicHeight._getAdBlockVisibleHeight());
                observer.observe($banner[0], { childList: true, subtree: true });
            };
            observer = createMutationObserver(do_showYandexDirectItems);
            do_showYandexDirectItems();
        } else if (showYandexDirectItems.__counter < 4) {
            setTimeout(showYandexDirectItems, 250 * showYandexDirectItems.__counter + 100);
            showYandexDirectItems.__counter++;
        }
    }
}, 100);

showYandexDirectItems.__counter = 3;
showYandexDirectItems.__observed = false;

export const publicHeight = {
    init() {
        if (!IS_PUBLIC) {
            return;
        }

        detectMutationObserverType();

        this._findBlocks();
        this._calcConstantOffsets();
        this._initResizeEvent();
        this.updateContentHeight();
        this.checkBannerState();
    },

    _getAdBlockVisibleHeight() {
        const IS_STICKY = isStickyBanners;
        const STICKY_HEIGHT = 72;
        const BLOCK_CONTAINER = $('body');
        const BASE_HEIGHT = BLOCK_CONTAINER.height();
        const SCROLL_POSITION = $(document).scrollTop();
        const SCROLL_HEIGHT = document.body.scrollHeight;
        let availableHeight = 0;
        const PUBLIC_WRAPPER_OFFSET = this.$publicWrapper.offset() || { top: 0 };
        const footerPushHeight = this.$footerPush.outerHeight() + 20;

        const TOP_SEGMENT = IS_STICKY ? STICKY_HEIGHT + 10 : PUBLIC_WRAPPER_OFFSET - SCROLL_POSITION;

        const BOTTOM_SEGMENT = -Math.min(SCROLL_HEIGHT - SCROLL_POSITION - BASE_HEIGHT - footerPushHeight, 0);

        availableHeight = BASE_HEIGHT - TOP_SEGMENT - BOTTOM_SEGMENT;

        return availableHeight;
    },

    _findBlocks() {
        this.$app = $('#app');
        this.$public = $('#public', this.$app);
        this.$footerPush = $('.footer__push');
        this.$directWorm = $('#' + config.get('DOM_ID_WORM'));
        this.$publicBanner = $('.' + DOM_RIGHT_COL_BANNER, this.$public);
        this.$publicWrapper = $('.w-public__content', this.$public);
        this.$publicPhoneHeaderDirect = $(`#${app.getParam('DOM_ID_PHONE_PUBLIC_HEADER')}`);

        this._findPublicContent();

        this.$publicContentTitle = $('.public__content__title', '#public-file .public__content');
        this.$publicBreadcrumbs = $('#react-breadcrumbs');

        this._findPublicContentInner();

        /* if ( app.isChoosedPublicFile() ) {
					this.$publicContentSocialIcons = $('.js-public__content__social-icons', '#public-file .public__content');
				} else {
					this.$publicContentSocialIcons = $('.js-public__content__social-icons', '#content');
				}*/

        this.$publicContentSocialIcons = $('.b-mobile-share');
    },

    _findPublicContent() {
        if (Public.isChoosedPublicFile()) {
            // CLOUDWEB-5741, CLOUDWEB-5453 если на мобильном устройстве
            // открыть в публичной папке файл без предпросмотра,
            // то на странице будет 2 элемента .public__content
            if (IS_PUBLIC_SHOVE) {
                this.$publicContent = this.$publicWrapper;
            } else {
                // CLOUDWEB-6770
                // Блок #public-file инициализируется на клиентской
                // стороне (PublicFile.js), поэтому возникают случаи, когда
                // в DOM модели еще не существует элемента #public-file,
                // соответственно поиск вложенного в него селектора
                // .public__content не выполняется. Далее .public__content__inner
                // также отдается пустой коллекцией элементов jQuery.
                this.$publicContent = $('#public-file .public__content', this.$publicWrapper);
            }
        } else {
            this.$publicContent = $('.public__content', this.$publicWrapper);
        }
    },

    _findPublicContentInner() {
        this.$publicContentInner = $('.public__content__inner, #shoved-public-file', this.$publicContent);
    },

    _calcConstantOffsets() {
        this.publicMarginTop = parseInt(this.$public.css('margin-top')) || 0;
        this.publicWrapperMinHeight = parseInt(this.$publicWrapper.css('min-height')) || 0;
        this.appPaddingBottom = parseInt(this.$app.css('padding-bottom'), 10) || 0;
        this.publicWrapperMargin = parseInt(this.$publicWrapper.css('margin-bottom'), 10) || 0;
    },

    _initResizeEvent() {
        if (!this._eventInited) {
            this._eventInited = true;

            const updateContentHeight = throttle(this.updateContentHeight.bind(this), 100);
            const yandexDirectResizeHandler = throttle(
                function () {
                    showYandexDirectItems(this._getAdBlockVisibleHeight());
                }.bind(this),
                100
            );

            const handler = () => {
                updateContentHeight();

                if (!IS_MOBILE) {
                    yandexDirectResizeHandler();
                }
            };

            window.addEventListener('resize', handler);
        }
    },

    updateContentHeight() {
        if (!IS_PUBLIC || !(this.$publicWrapper && this.$publicWrapper.length)) {
            return;
        }
        let publicContentBorderWidth;

        // Изначально minHeight под контент равен высоте
        // окна браузера;
        let minHeight = $(window).height();

        // Вычитаем из этого значения отступ от
        // верхней границы окна браузера до
        // верхней границы элемента .w-public__content
        minHeight -= this.$publicWrapper.offset().top;

        // Вычитаем размер высоты .public__content__title
        minHeight -= this.$publicContentTitle.outerHeight();

        // Вычитаем высоту элемента навигации, если он есть
        minHeight -= this.$publicBreadcrumbs.outerHeight();

        if (!IS_MOBILE && Public.isChoosedPublicFolder() && !IS_PUBLIC_SHOVE && !HIDE_ADS) {
            // Если устройство не является телефоном и планшетом,
            // то вычитаем значение рекламного блока Yandex Direct
            //minHeight -= this.$directWorm.outerHeight();
            // Сейчас этот блок рисуется реактом после этого кода, так что костылим явное вычитание
            minHeight -= 37;
        }

        // вычитаем отступ, если это паблик-папка с брендированием
        if (Public.isChoosedPublicFolder() && IS_PUBLIC_SHOVE) {
            minHeight -= 13;
        }

        if (this.$footerPush.is(':visible')) {
            // display:none в телефонной версии
            // Вычитаем значение высоты .footer_push элемента
            minHeight -= this.$footerPush.outerHeight();
        }

        // Если есть - значит включена фича "черный паблик"
        // и добавлен дополнительный отступ над рекламной строчкой
        minHeight -= this.publicMarginTop;

        minHeight -= $('#react-public-upload').outerHeight();

        if (!IS_PHONE) {
            // у элемента .public__content__inner
            // задано свойство box-sizing: border-box;
            // поэтому нет смысла учитывать его
            // верхнюю и нижнюю границы при расчете minHeight
            // Ранее было minHeight -= this.innerPadding;
            minHeight -= this.appPaddingBottom;
        } else {
            // Если существует блок с социальными кнопками, то
            // для телефонов необходимо вычитать его высоту также,
            // так как он располагается в самом низу страницы.
            minHeight -= this.$publicContentSocialIcons.outerHeight();

            // Добавляем высоту рекламы, тк выше выше вычитаем отступ сверху до контента
            minHeight += this.$publicPhoneHeaderDirect.outerHeight();
        }

        // В CSS стилях для элемента .w-public__content
        // задано значение min-height: 450px;
        // minHeight не должен быть меньше этого значения
        // на desktop
        if (!IS_MOBILE && this.publicWrapperMinHeight > minHeight) {
            minHeight = this.publicWrapperMinHeight;
        }

        // Если есть (fallback - значение 0), то вычитаем
        // значение margin-bottom элемента .w-public__content
        // из minHeight
        minHeight -= this.publicWrapperMargin;

        // Также необходимо вычитать верхнюю (1px) и нижнюю (1px) границу
        // элемента .public__content, несмотря на то, что
        // .public__content имеет border-box блочную модель.
        // Эти 2 пиксела занимают место у контента и влияют на
        // document.body.scrollTop -> вертикальный скроллбар.
        // Это правило действует только для desktop
        if (!IS_MOBILE) {
            publicContentBorderWidth = parseInt(this.$publicContent.css('border-top-width'), 10);
            minHeight -= isNaN(publicContentBorderWidth) ? 0 : publicContentBorderWidth;

            publicContentBorderWidth = parseInt(this.$publicContent.css('border-bottom-width'), 10);
            minHeight -= isNaN(publicContentBorderWidth) ? 0 : publicContentBorderWidth;
        }

        // У датилиста в режиме списка добавлен верхний маржин,
        // чтобы соответствовать отступу у плиток в режиме плитки или галереи
        // CLOUDWEB-9477
        if (!IS_MOBILE && Public.isChoosedPublicFolder()) {
            const publicContentInnerMarginTop = parseInt(this.$publicContentInner.css('margin-top'), 10);
            minHeight -= isNaN(publicContentInnerMarginTop) ? 0 : publicContentInnerMarginTop;
        }

        const cssHeightPropPrev = this.cssHeightProp;
        this.cssHeightProp = Public.isChoosedPublicFolder() || IS_PHONE ? 'min-height' : 'height';
        if (IS_PUBLIC_SHOVE) {
            this.cssHeightProp = 'height'; // !app.isChoosedPublicFolder() ? 'min-height' : 'height';
        }

        this.$publicContentInner.css(
            this.cssHeightProp,
            IS_PHONE ? Math.max(minHeight, MIN_HEIGHT_MOBILE) : Math.max(minHeight, MIN_HEIGHT)
        );

        if (this.cssHeightProp !== cssHeightPropPrev && cssHeightPropPrev) {
            this.$publicContentInner.css(cssHeightPropPrev, 'inherit');
        }

        if (!IS_MOBILE) {
            this.updateBannerPosition(isStickyBanners);
        }
    },

    isEmpty: true,

    checkBannerState() {
        // CLOUDWEB-3826
        const oldIsEmpty = this.isEmpty;
        const _this = this;

        // checkBannerEmpty
        if (createMutationObserver && this.$publicBanner.length) {
            this.isEmpty =
                this.$publicBanner.find(':not(script)').text().trim().length === 0 &&
                this.$publicBanner.find('iframe,embed,object').length === 0 &&
                !Array.some(this.$publicBanner.find('img'), function (img) {
                    return !!(img.height && img.width);
                });

            if (this.isEmpty) {
                if (this._observer) {
                    this._observer.disconnect();
                }

                this._observer = createMutationObserver(function () {
                    _this._observer.disconnect();
                    _this._observer = null;

                    _this.checkBannerState();
                });

                this._observer.observe(this.$publicBanner[0], { childList: true, subtree: true, characterData: true });
            }
        } else {
            this.isEmpty = false;
        }

        if (!this.isEmpty) {
            this.$publicBanner.removeClass(DOM_RIGHT_COL_BANNER_EMPTY);
        }

        if (oldIsEmpty != this.isEmpty) {
            setTimeout(function () {
                _this.updateBannerPosition(isStickyBanners);

                _this.$publicBanner.removeClass(DOM_RIGHT_COL_BANNER_NOT_INITED); // CLOUDWEB-5930
            }, 200);
        }
    },

    updateBannerPosition(isFixed) {
        const top = 10;
        if (this.isEmpty || !this.$publicBanner.is(':visible')) {
            if (isFixed === true) {
                this.__lastIsFixed = isFixed;
            }

            return;
        }

        if (isFixed == void 0) {
            if (this.__lastIsFixed != void 0) {
                // не нужно высчитывать позицию, если позиция уже установлена
                return;
            }
            isFixed = false;
        }

        const isFixedChanged = this.__lastIsFixed != isFixed;
        this.__lastIsFixed = isFixed;

        let parentWidth = this.__parentWidth;
        if (!parentWidth) {
            parentWidth = this.__parentWidth = this.$publicBanner.parent().width();
        }

        this.__lastTop = top;

        this.$publicBanner.css({
            position: isFixed ? 'fixed' : '',
            width: parentWidth,
        });

        this.setBannerPosition(top, isFixed);

        if (isFixedChanged) {
            showYandexDirectItems(this._getAdBlockVisibleHeight());
        }
    },

    setBannerPosition(top, isFixed) {
        if (top == void 0) {
            top = this.__lastTop;
        }

        if (isFixed == void 0) {
            isFixed = this.__lastIsFixed;
        }

        let portalFooterHeight = this.__portalFooterHeight;
        if (portalFooterHeight == void 0) {
            portalFooterHeight = this.__portalFooterHeight = $('#w-portal-footer').height() + parseInt($('#app').css('padding-bottom'));
        }

        let bannerPadding = this.__bannerPadding;
        if (bannerPadding == void 0) {
            bannerPadding = this.__bannerPadding =
                parseInt(this.$publicBanner.css('padding-top')) + parseInt(this.$publicBanner.css('padding-bottom'));
        }

        let alpha = 0;
        if (IS_OPERA && isFixed) {
            alpha = top - 20; // magic fix for banner fixed position in Opera 12-
        } else if (isFixed) {
            alpha =
                document.body.scrollHeight -
                (document.body.scrollTop + this.$publicBanner.outerHeight() + portalFooterHeight + bannerPadding);
        }

        if (alpha < top) {
            top = alpha;
        }

        this.$publicBanner.css({
            top: isFixed ? top + 'px' : '',
        });
    },

    /**
     * Возвращает размеры блока с только контентом
     */
    getClientDimensions() {
        if (!this.$publicContentInner) {
            return;
        }
        let $clientContainer;
        // CLOUDWEB-6770;
        if (!this.$publicContentInner.length) {
            this._findPublicContent();
            this._findPublicContentInner();
        }

        $clientContainer = this.$publicContentInner;
        return {
            width: $clientContainer.width(),
            height: $clientContainer.height(),
        };
    },

    /**
     * Возвращает размеры полного блока с контентом (вместе с описанием контента и рекламой сверху)
     */
    getContentOuterClientDimensions() {
        if (!this.$publicContentInner) {
            return;
        }
        // CLOUDWEB-6770;
        if (!this.$publicContentInner.length) {
            this._findPublicContent();
        }

        const $clientContainer = this.$publicContent;
        return {
            width: $clientContainer.outerWidth(),
            height: $clientContainer.outerHeight(),
        };
    },
};

app.on('routeEnd', () => {
    if (IS_PUBLIC && !isReactMobilePublic) {
        publicHeight.init();
        isInited = true;

        if (!isInited) {
            $(window).on(
                'scroll',
                throttle(function () {
                    publicHeight.setBannerPosition();
                }, 200)
            );
        }
    }
});
